import { useCallback, useMemo } from 'react';
import useIsMobile from '../features/shared/Hooks/useIsMobile';

const getVisibility = (visibilityConfig: VisibilityVariant | undefined, isMobile: boolean) => {
  if (!visibilityConfig || visibilityConfig === 'mobileAndDesktop') return true;
  if (isMobile && visibilityConfig === 'mobileOnly') return true;
  return !isMobile && visibilityConfig === 'desktopOnly';
};

export const useVisibility = (
  visibilityConfig?: VisibilityVariant | undefined,
): { isVisible: boolean; getLinkVisibility: (link: LinkType) => boolean } => {
  const isMobile = useIsMobile();

  const isVisible = useMemo(
    () => getVisibility(visibilityConfig, isMobile),
    [visibilityConfig, isMobile],
  );

  const getLinkVisibility = useCallback(
    (link: LinkType) => getVisibility(link.visibility, isMobile),
    [isMobile],
  );

  return {
    isVisible,
    getLinkVisibility,
  };
};
